/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Present if Fuel payment failed due to insufficient balance
 * @export
 * @interface InsufficientBalanceInfo
 */
export interface InsufficientBalanceInfo {
    /**
     * 
     * @type {number}
     * @memberof InsufficientBalanceInfo
     */
    currentBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof InsufficientBalanceInfo
     */
    requiredAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InsufficientBalanceInfo
     */
    shortfall?: number;
    /**
     * 
     * @type {number}
     * @memberof InsufficientBalanceInfo
     */
    shortfallUsd?: number;
}

/**
 * Check if a given object implements the InsufficientBalanceInfo interface.
 */
export function instanceOfInsufficientBalanceInfo(value: object): value is InsufficientBalanceInfo {
    return true;
}

export function InsufficientBalanceInfoFromJSON(json: any): InsufficientBalanceInfo {
    return InsufficientBalanceInfoFromJSONTyped(json, false);
}

export function InsufficientBalanceInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsufficientBalanceInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentBalance': json['currentBalance'] == null ? undefined : json['currentBalance'],
        'requiredAmount': json['requiredAmount'] == null ? undefined : json['requiredAmount'],
        'shortfall': json['shortfall'] == null ? undefined : json['shortfall'],
        'shortfallUsd': json['shortfallUsd'] == null ? undefined : json['shortfallUsd'],
    };
}

export function InsufficientBalanceInfoToJSON(json: any): InsufficientBalanceInfo {
    return InsufficientBalanceInfoToJSONTyped(json, false);
}

export function InsufficientBalanceInfoToJSONTyped(value?: InsufficientBalanceInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentBalance': value['currentBalance'],
        'requiredAmount': value['requiredAmount'],
        'shortfall': value['shortfall'],
        'shortfallUsd': value['shortfallUsd'],
    };
}

